import FilterChip from 'LuxKit/Chips/FilterChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import ModalContext from 'contexts/ModalContext'
import { OfferPageActions, takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback, useContext, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import OfferCalendarRoomModal from './OfferCalendarRoomModal'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'

interface Props {
  open: boolean
  variant?: 'dropdown' | 'modal'
}

function OfferCalendarRoomSelect(props: Props) {
  const { open, variant = 'dropdown' } = props
  const intl = useIntl()
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)
  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
    if (open) {
      onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
    } else {
      onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.OpenSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
    }
  }, [dispatch, onUserAnalyticsAction, open])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
    onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
  }, [dispatch, onUserAnalyticsAction])

  useEffect(() => {
    if (open && variant === 'modal') {
      showModal(<OfferCalendarRoomModal />).then(() => {
        onClose()
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <>
      <FilterChip
        size="medium"
        ref={triggerRef}
        onClick={onToggleOpen}
        endIcon={variant === 'dropdown' ? <DropdownChevron open={open} /> : undefined}
        selected={open}
      >
        {intl.formatMessage({
          id: 'DGf_sV9ivcF1fhJAJQ5R',
          defaultMessage: 'Filter by room',
          description: 'Chip label for filtering by room type in offer calendar',
        })}
      </FilterChip>
      {variant === 'dropdown' && <DropdownList
        size="S"
        title={intl.formatMessage({
          id: 'f7FfUXHq8a854-jy9Chr',
          defaultMessage: 'Rooms',
          description: 'Heading title for the rooms dropdown list in the offer calendar',
        })}
        open={open}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        hasDismissButton
        onClose={onClose}
      >
        <OfferCalendarRoomOptions onSelect={onClose} />
      </DropdownList>}
    </>
  )
}

export default withOfferPageState((currentState) => {
  const state = takeCurrentOfferState(currentState)

  return {
    open: state.activeSubFilter === 'room',
  }
}, OfferCalendarRoomSelect)
